import { render, staticRenderFns } from "./PermissionsInfo.vue?vue&type=template&id=29439d11&scoped=true"
import script from "./PermissionsInfo.vue?vue&type=script&lang=ts"
export * from "./PermissionsInfo.vue?vue&type=script&lang=ts"
import style0 from "./PermissionsInfo.vue?vue&type=style&index=0&id=29439d11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29439d11",
  null
  
)

export default component.exports